export default __webpack_public_path__ + "static/media/7.a4e0d08e.png";